import { useState } from 'react';
import { Gauge } from 'lucide-react';
import { useTicketsStore } from '@/features/tickets';
import { ticketsApi } from '@/shared/api/tickets';
import { apiErrorText, type KpiComplexityLevel } from '@/shared/api';
import type { TicketDetailData } from '@/entities/ticket';
import { toast } from '@/shared/ui';
import { cn } from '@/shared/lib/cn';
import { cnChip } from './lib';
import styles from './TicketDetail.module.css';

export const ComplexityRequestCallout: React.FC<{
  ticket: TicketDetailData;
  isAgent: boolean;
  canRateComplexity: boolean;
  complexityLevels: KpiComplexityLevel[];
}> = ({ ticket, isAgent, canRateComplexity, complexityLevels }) => {
  const fetchTicket = useTicketsStore((s) => s.fetchTicket);
  const [busy, setBusy] = useState(false);

  if (!isAgent || ticket.complexityRequestedClass == null) return null;

  const requested =
    complexityLevels.find((l) => l.class === ticket.complexityRequestedClass)?.label ??
    `класс ${ticket.complexityRequestedClass}`;

  const decide = async (approve: boolean) => {
    if (busy) return;
    setBusy(true);
    try {
      await ticketsApi.decideComplexity(ticket.id, approve);
      fetchTicket(ticket.id);
    } catch (err) {
      toast.error(apiErrorText(err, 'Не удалось ответить на запрос сложности'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={cn(styles.resolutionCallout, styles.resolutionPending)} role="status">
      <div className={styles.resolutionHead}>
        <span className={styles.resolutionIcon} aria-hidden>
          <Gauge size={18} />
        </span>
        <p className={styles.resolutionText}>
          <strong>Запрос сложности</strong> — {requested}
          {ticket.complexityRequestComment ? `: «${ticket.complexityRequestComment}»` : ''}
        </p>
      </div>
      {canRateComplexity && (
        <div className={styles.chipRow}>
          <button type="button" className={cnChip(false)} disabled={busy} onClick={() => void decide(true)}>
            одобрить
          </button>
          <button type="button" className={cnChip(false)} disabled={busy} onClick={() => void decide(false)}>
            отклонить
          </button>
        </div>
      )}
    </div>
  );
};
